import React, { useState, useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { Tabs } from "antd";
import Log from "./Log";
import Task from "./Task";
import Event from "./Event";
import { useDispatch } from "react-redux";
import { useCrm_task_statuses } from "../../../../hooks";
import moment from "moment";
import { createRecord } from "../../../../features/crm/activities/activitiesSlice";
import Mail from "./Mail";

const Activity = ({
  entity,
  entityId,
  branchId,
  onReloadFeed,
  sider,
  stretched,
  collapsed,
  branches,
  hasEmail,
}) => {
  const statuses = useCrm_task_statuses();
  const [refreshFormTimestamp, setRefreshFormTimestamp] = useState();
  const [values, setValues] = useState({});
  const dispatch = useDispatch();
  const intl = useIntl();
  const createActivity = useCallback(
    async (val) => {
      const params = {
        ...val,
        entity,
        entityId,
        scope: `branches/${branchId}`,
      };
      const action = await dispatch(createRecord(params));
      if (!action.error) {
        onReloadFeed();
        setValues({});
      }
      setRefreshFormTimestamp(moment().format());
    },
    [dispatch, entity, entityId, branchId, onReloadFeed]
  );

  const onFormChange = useCallback((values, all) => {
    setValues(all);
  }, []);

  const tabs = useMemo(() => {
    const baseTabs = [
      {
        label: intl.formatMessage({ id: "app.activities.log_a_call" }),
        key: "1",
        children: (
          <Log
            createActivity={createActivity}
            statuses={statuses}
            refreshFormTimestamp={refreshFormTimestamp}
            collapsed={collapsed}
            stretched={stretched}
          />
        ),
      },
      {
        label: intl.formatMessage({ id: "app.activities.new_task" }),
        key: "2",
        children: (
          <Task
            createActivity={createActivity}
            statuses={statuses}
            refreshFormTimestamp={refreshFormTimestamp}
            stretched={stretched}
            branchId={branchId}
            sider={sider}
            branches={branches}
            entity={entity}
          />
        ),
        forceRender: true,
      },
      {
        label: intl.formatMessage({ id: "app.activities.new_event" }),
        key: "3",
        children: (
          <Event
            createActivity={createActivity}
            statuses={statuses}
            refreshFormTimestamp={refreshFormTimestamp}
            onChange={onFormChange}
            values={values}
            stretched={stretched}
            sider={sider}
          />
        ),
      },
    ];

    if (hasEmail) {
      baseTabs.push({
        label: intl.formatMessage({ id: "app.activities.new_mail" }),
        key: "4",
        children: (
          <Mail
            createActivity={createActivity}
            statuses={statuses}
            refreshFormTimestamp={refreshFormTimestamp}
            collapsed={collapsed}
            stretched={stretched}
          />
        ),
      });
    }

    return baseTabs;
  }, [
    intl,
    createActivity,
    statuses,
    refreshFormTimestamp,
    collapsed,
    stretched,
    branchId,
    sider,
    onFormChange,
    values,
    entity,
    branches,
    hasEmail,
  ]);

  return (
    <div className="component">
      <div style={{ height: "auto" }}>
        <Tabs defaultActiveKey="1" items={tabs} />
      </div>
    </div>
  );
};

export default Activity;
